import logo from './logo.svg';
import './App.css';
import React from 'react';
import Appbar from '../src/Appbar'
import Box from '@mui/material/Box';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Vendors, { Vendorsc } from './Vendors/Vendors';
import VendorsList, { VendorsListc } from './Vendors/VendorsList';
import AddFranchise, { AddFranchisec } from './Franchise/AddFranchise';
import FranchiseList, { FranchiseListc } from './Franchise/FranchiseList';
import Customer from './Cutomers/Customer';
import Settings from './Setting/Settings';
import EditVendor, { EditVendorc } from './Vendors/EditVendor'
import { EditFranchisec } from './Franchise/EditFranchise';
import { PendingVendorListc } from './Vendors/PendingVendor/PendingVendorList';
import { PendingVendorDescc } from './Vendors/PendingVendor/PendingVendorDesc';
import Ordders from './Orders/Ordders';
import Login from '../src/Login'




function App() {
  return (
    <Box sx={{backgroundColor:'#f2f2f2',minHeight:'100vh',width:'100%'}}> 
<Appbar/>

  <React.StrictMode>
    <RouterProvider router={createBrowserRouter([


/////////////// admin section //////////


{
  path: "/" ,
  element:<Login/>,
},

    {
      path: "/dashboard" ,
      element:<Dashboard/>,
    },


    ///////// vendor section ///////////

         {
      path: "/Vendors" ,
      element:<Vendorsc/>,
    },

    {
      path: "/VendorsList" ,
      element:<VendorsListc/>,
    },

    {
      path: "/editVendor/:id" ,
      element:<EditVendorc/>,
    },
   

        {
      path: "/pendingVendor" ,
      element:< PendingVendorListc/>,
    },

           {
      path: "/pendingVendorDesc/:id" ,
      element:<PendingVendorDescc/>,
    },
   





   {
      path: "/Franchise" ,
      element:<AddFranchisec/>,
    },
   
       {
      path: "/frenchiseList" ,
      element:<FranchiseListc/>,
      },

           {
      path: "/frenchise/:id" ,
      element:<EditFranchisec/>,
      },
   
         {
      path: "/Customer" ,
      element:<Customer/>,
    },


             {
      path: "/Settings" ,
      element:<Settings/>,
    },

       

             {
      path: "/Orders" ,
      element:<Ordders/>,
    },












    

    
])} />

</React.StrictMode>
    </Box>
  );
}

export default App;
